import script from "./FisherTransform.vue?vue&type=script&lang=js"
export * from "./FisherTransform.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__